// extracted by mini-css-extract-plugin
export default {"dropzone":"styles_dropzone__BliG9","droptarget":"styles_droptarget__2toUe","availableTarget":"styles_availableTarget__Y2Fvi","pageCover":"styles_pageCover__RZXt7"};